import React, { useEffect, useState, useRef } from "react";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { InputField } from "../../../components";
import Loading from "../../../components/Loader/Loading";
export default function AddUpdateForm({
  handleModal,
  fetchData,
  isLoading,
  setIsLoading,
  records,
}) {
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    domain: "",
    out_reach_source: "",
    live_url: "",
  });

  useEffect(() => {
    if (records?.["dor.id"]) {
      setFormData({
        domain: records?.["dor.domain"],
        out_reach_source: records?.["dor.out_reach_source"],
        live_url: records?.["dor.live_url"],
        note: records?.["dor.note"],
        status: records?.["dor.status"],
        verified_by: records?.["dor.verified_by"],
        verified_at: records?.["dor.verified_at"],
      });
    } else {
      setFormData({
        domain: "",
        out_reach_source: "",
        live_url: "",
      });
    }
  }, [records]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const newErrors = {};

    if (!formData.domain.trim()) newErrors.domain = "Please enter the domain.";
   /*  if (!formData.out_reach_source.trim()) {
      newErrors.out_reach_source = "Please enter the outreach source.";
    }
    if (!formData.live_url.trim()) {
      newErrors.live_url = "Please enter the live URL.";
    } */

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsLoading(false);
      return;
    }
    if (!records?.["dor.id"]) {
      api
        .post(
          `${process.env.REACT_APP_PUBLIC_API}/api/domains/out_reach`,
          formData
        )
        .then(() => {
          handleModal();
          fetchData();
          toast.success("Domain Outreach Created!", { autoClose: 3000 });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (records?.["dor.id"]) {
      api
        .put(`${process.env.REACT_APP_PUBLIC_API}/api/domains/out_reach/${records?.["dor.id"]}`, {
          ...formData,
        })
        .then(() => {
          handleModal();
          fetchData();
          toast.success("Domain Outreach updated successfully!", { autoClose: 3000 });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const clearError = (field, condition = true) => {
    if (condition) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const multiSelectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdownEl = multiSelectRef.current?.getElement();
      const panelEl = document.querySelector(".p-multiselect-panel");

      if (
        dropdownEl &&
        panelEl &&
        !dropdownEl.contains(event.target) &&
        !panelEl.contains(event.target)
      ) {
        multiSelectRef.current?.hide();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      {isLoading && records?._id && <Loading />}
      <div className="grid md:grid-cols-1 gap-4 w-full">
        <InputField
          label="Domain"
          name="domain"
          placeholder="Enter domain name"
          value={formData.domain}
          onChange={(e) => {
            setFormData({ ...formData, domain: e.target.value });
            clearError("domain", e.target.value.trim());
          }}
          error={errors.domain}
          required
        />
        <InputField
          label="Outreach Source"
          name="out_reach_source"
          placeholder="Enter outreach source"
          value={formData.out_reach_source}
          onChange={(e) => {
            setFormData({ ...formData, out_reach_source: e.target.value });
            clearError("out_reach_source", e.target.value.trim());
          }}
          error={errors.out_reach_source}
          required
        />
        <InputField
          label="Live URL"
          name="live_url"
          placeholder="Enter live URL"
          value={formData.live_url}
          onChange={(e) => {
            const value = e.target.value;
            setFormData({ ...formData, live_url: value });

            if (!value.trim()) {
              setErrors((prev) => ({
                ...prev,
                live_url: "Please enter the live URL.",
              }));
            } else {
              clearError("live_url");
            }
          }}
          error={errors.live_url}
          required
        />
      </div>

      <div className="flex items-cente justify-end mt-5 space-x-2 text-white">
        <button
          onClick={handleModal}
          type="button"
          className="btnPrimary bg-red-500"
        >
          Cancel
        </button>

        {isLoading ? (
          <div className="bg-blue/10 flex items-center justify-center rounded-md py-2 w-48">
            <img src="/img/loading.gif" className="w-7" alt="" />
          </div>
        ) : (
          <button
            type="button"
            onClick={handleSubmit}
            className="btnPrimary bg-green-600"
          >
            Save and Update
          </button>
        )}
      </div>
    </div>
  );
}
